<mat-expansion-panel [expanded]="autoExpand" class="mat-elevation-z0">
  <mat-expansion-panel-header>
    <mat-panel-title class="bold">
      {{ 'common.labels.filters' | transloco }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="_filterForm" class="padding">
    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.description' | transloco }}</mat-label>
        <input matInput [formControlName]="'description'" [placeholder]="'common.labels.description' | transloco" />
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-select [formControlName]="'batchTypeIDs'" [placeholder]="'bundles.batchType' | transloco" multiple="true">
          @for (option of _batchTypes; track option) {
            <mat-option [value]="option.value">
              {{ option.label | transloco }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
        (click)="onClear()" [disabled]="!_filterForm.dirty">
        {{ 'common.labels.clearFilters' | transloco }}
      </button>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
        (click)="onFilter()">
        {{ 'common.labels.filter' | transloco }}
      </button>
    </div>
  </form>
</mat-expansion-panel>